import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Elena R.',
    age: '46 años',
    text: 'Bajé 4 kilos y 8 cm de cintura en 3 semanas sin pasar hambre ni un solo día. Lo mejor es que por fin volví a dormir toda la noche sin despertarme empapada en sudor.'
  }, {
    name: 'Mónica S.',
    age: '51 años',
    text: "Pensé que mi metabolismo estaba roto para siempre. Este programa me enseñó que estaba comiendo 'saludable' pero de forma incorrecta para mis hormonas. Mi energía se ha triplicado."
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-187">
      <div className="max-w-5xl mx-auto" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-189">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-190">
            Mujeres Reales. Resultados Reales.
          </h2>
          <p className="text-lg text-dark-light" data-id="element-191">
            Únete a cientos de mujeres que ya han recuperado su vitalidad.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-192">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-sage/10 relative" data-id="element-193">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-sage/10 rotate-180" data-id="element-194" />

              <div className="flex gap-1 mb-6" data-id="element-195">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-196" />)}
              </div>

              <p className="text-dark-light text-lg italic mb-8 relative z-10" data-id="element-197">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-198">
                <div className="w-12 h-12 bg-sage-light/30 rounded-full flex items-center justify-center text-sage-dark font-bold font-heading text-xl" data-id="element-199">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-200">
                  <p className="font-bold text-dark" data-id="element-201">{testimonial.name}</p>
                  <p className="text-sm text-dark-light" data-id="element-202">{testimonial.age}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}